import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#007DFF',
      light: '#3397FF',
      dark: '#0057B2',
      contrastText: '#fff',
    },
    secondary: {
      main: '#FF505F',
      light: '#FF737F',
      dark: '#B23842',
      contrastText: '#fff',
    },
    error: {
      main: '#F44336',
      light: '#F88078',
      dark: '#E31B0C',
      contrastText: '#fff',
    },
    warning: {
      main: '#FF9800',
      light: '#FFB547',
      dark: '#C77700',
      contrastText: '#000',
    },
    info: {
      main: '#2196F3',
      light: '#64B6F7',
      dark: '#0057B2',
      contrastText: '#fff',
    },
    success: {
      main: '#4CAF50',
      light: '#7BC67E',
      dark: '#3B873E',
      contrastText: '#fff',
    },
    globalSearch: {
      link: 'rgba(0, 125, 255, 1)',
      text: 'rgba(0, 0, 0, 0.26)',
    },
  },
});

export default theme;
